import autoSizeColumns from "./AGGridAutoSizeCols";

export default {
  getRowHeight: (params) => params.node.rowHeight < 45 ? 45 : params.node.rowHeight,
  suppressClickEdit: true,
  suppressCellFocus: true,
  enableCellTextSelection: true,
  onGridReady: (params) => autoSizeColumns(params, null),
  defaultColDef: {
    wrapText: true,
    minWidth: 50,
    autoHeight: true,
  }
}